import { GapVM } from "./gapVM";

export class GapViewModel {
  public durationSeconds: number;
  public startTime: string;
  public isVisible: boolean;
  public className: string;
  public margin: number;
  public width: number;

  constructor(gap: GapVM, totalDurationSeconds: number, startDateUnix: number, videoWidth: number) {
    this.durationSeconds = gap.durationSeconds;
    this.startTime = gap.startTime.endsWith("Z") ? gap.startTime : `${gap.startTime}Z`;
    this.isVisible = gap.isVisible;
    this.margin = this.getMargin(videoWidth, startDateUnix, totalDurationSeconds);
    this.className = gap.isVisible ? "hash-pattern-gap" : "transparent-gap";
    this.width = this.getWidth(totalDurationSeconds, videoWidth);
  }

  private getMargin(
    videoWidth: number,
    startDateUnix: number,
    totalDurationSeconds: number
  ): number {
    const gapStartDateUnix = new Date(this.startTime).getTime();
    const secondsSinceStart = (gapStartDateUnix - startDateUnix) / 1000;
    return (secondsSinceStart / totalDurationSeconds) * videoWidth;
  }

  private getWidth(totalDurationSeconds: number, videoWidth: number): number {
    const width = (this.durationSeconds / totalDurationSeconds) * videoWidth;
    const maxWidth = videoWidth - this.margin;
    return width > maxWidth ? maxWidth : width;
  }
}
